import { createContext } from 'react';
import { PersistentNotificationsContextType } from './types';

export const PersistentNotificationsContext = createContext<PersistentNotificationsContextType>(
  {} as unknown as PersistentNotificationsContextType,
);
